
/*
extend
* */
export function extend() {
    let arg1 = arguments[0], arg2;
    for(let i = 1; i < arguments.length; i++){
        arg2 = arguments[i] ? arguments[i] : [];
        for(let k in arg2){
            arg1[k] = arg2[k];
        }
    }
    return arg1;
}


/*
getParam
* */
export function getParam(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let l = window.location.href.split('?');
    if(l[1]) {
        let r = l[1].match(reg);
        if(r) {
            return unescape(r[2]);
        }
    }
    return null;
}


/*
getAgent
* */
export function getAgent() {

    if(/(Android)/i.test(navigator.userAgent)){
        return 1; // android
    }
    else if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
        return 2; // ios
    }
    else{
        return 3; // pc
    }
}


/*
hexToRgba
* */
export function hexToRgba(color, opacity) {
    opacity = opacity || 1;

    let sColor = color.toLowerCase();

    //十六进制颜色值的正则表达式
    let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

    // 如果是16进制颜色
    if (sColor && reg.test(sColor)) {

        if (sColor.length === 4) {
            let sColorNew = "#";
            for (let i = 1; i < 4; i += 1) {
                sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
        }

        //处理六位的颜色值
        let sColorChange = [];

        for (let i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }

        return "rgba(" + sColorChange.join(",") + ", " + opacity + ")";
    }

    return sColor;
}


/****特殊模块显示状态处理*****/
export function isShow(value,states) {

    /*
    * value 指当前状态值
    * states 指所允许显示值集合数组
    * */
    if(states.some(function (item,index,self) {return item == value;}))return true;

    return false;

}


/************时间戳转换为日期格式***************/
export function dataFormat() {

    //日期格式修改时间戳转换为时间格式
    Date.prototype.format = function(fmt) {
        var o = {
            "M+" : this.getMonth()+1,                 //月份
            "d+" : this.getDate(),                    //日
            "h+" : this.getHours(),                   //小时
            "m+" : this.getMinutes(),                 //分
            "s+" : this.getSeconds(),                 //秒
            "q+" : Math.floor((this.getMonth()+3)/3), //季度
            "S"  : this.getMilliseconds()             //毫秒
        };
        if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
        }
        for(var k in o) {
            if(new RegExp("("+ k +")").test(fmt)){
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
            }
        }
        return fmt;
    }

    Date.prototype.D_H_M = function (timer) {

        let $endTime =timer;

        let day=parseInt($endTime/1000/60/60/24),
            hour=parseInt($endTime/1000/60/60 % 24),
            min= parseInt($endTime/1000/60 % 60);

        $endTime = '';

        if(day>0){$endTime =day+'天'}
        if(hour>=0){$endTime +=hour+'时'}
        if(min>=0){$endTime +=min +'分'}

        return $endTime;
    }
}



/******获取平台信息*****/
export function $system() {

    if(/(Android)/i.test(navigator.userAgent)){
        return 1; // android
    }
    else if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
        return 2; // ios
    }
    else{
        return 3; // pc
    }

}


/**********获取系统环境*********/
export function $systemEnviron() {

    //判断H5是在APP环境 还是微信环境
    let ua = window.navigator.userAgent.toLowerCase();
    // 小程序
    if(ua.match(/miniProgram/i) == 'miniprogram') {
        return 2;
    }
    // 微信 h5
    else if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        return 1;
    }
    // app 环境
    else {
        return 3;
    }
}

//获取浏览器信息


//js原生同步请求
export  const getAjax={

    get: function(url,fn,async) {

        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, async);
        xhr.onreadystatechange = function() {
            // readyState == 4说明请求已完成
            if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
                // 从服务器获得数据
                fn.call(this, xhr.responseText);
            }
        };
        xhr.send();
    },


    post: function (url, data, fn,async) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, async);
        // 添加http头，发送信息至服务器时内容编码类型
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 304)) {
                fn.call(this, xhr.responseText);
            }
        };
        xhr.send(data);
    }
}


//兼容APP js
export function $wx_APP() {

    window.brtbeacon_app_beacon_search_callback = '';

    window.brtbeacon_app_ble_enable_callback = '';


    window.on_app_ble_enable_callback = function(args) {

        if ("1"==args){
            args = "location service disable";
        }else if("2"==args){
            args = "bluetooth power off";
        }else{
            args = "ok";
        }

        brtbeacon_app_ble_enable_callback({errMsg:args})
    }


    //新增通信信息
    window.onmessage = function(b) {
        b = b || event;



        var a =b.data && typeof b.data == 'string' ? JSON.parse(b.data) : b.data;
        if(a.key == "bleEnable") {
            on_app_ble_enable_callback(a.value)
        }
        if(a.key == "onSearchBeacons") {
            if(brtbeacon_app_beacon_search_callback) {
                brtbeacon_app_beacon_search_callback(a.value)
            }
        }
    };


    window.on_brtbeacon_beacon_search = function(args) {

        // console.log("on_brtbeacon_beacon_search ===>>>"+JSON.stringify(args));

        if (brtbeacon_app_beacon_search_callback) {
            brtbeacon_app_beacon_search_callback(args);
        }
    }



    window.brtbeacon_app_heading_callback='';

    window.on_app_heading_callback = function(heading){
        brtbeacon_app_heading_callback &&  brtbeacon_app_heading_callback(heading);
    }


    return {

        "config": function (obj) {

        },

        "ready": function (func) {
            func && func();
        },

        "hideMenuItems": function () {
        },
        "showMenuItems": function () {
        },
        "onMenuShareTimeline": function () {
        },
        "onMenuShareAppMessage": function () {
        },

        "stopSearchBeacons":function(obj){
            obj.complete();
            // console.log("open ==> stopSearchBeacons")
        },

        "onSearchBeacons": function (obj) {
            // console.log("open ==> onSearchBeacons")
            brtbeacon_app_beacon_search_callback = obj.complete;
        },

        "startSearchBeacons": function (obj) {
            // console.log("open ==> startSearchBeacons");
            brtbeacon_app_ble_enable_callback = obj.complete;
            try{
                zs && zs.bleEnable();
            }catch (e){
                console.log('开启扫描失败');
            }
        },

        "share": function(info) {
            zs && zs.share(info);
        },
        "detail": function(info) {
            // console.log("传递对象是:",info);
            zs && zs.detail(JSON.stringify(info));
        },
        "setHeading":function (callback) {
            brtbeacon_app_heading_callback = callback;
        }
    }
}



//判断点是否是在四边形内（向量积方式）
export function getCross(p1,p2,p){
    return (p2.lng - p1.lng) * (p.lat - p1.lat) - (p.lng - p1.lng) * (p2.lat - p1.lat);
}



export function IsPointInMatrix(A,B,C,D,E){

    var num1=getCross(A,B,E)*getCross(C,D,E);

    var num2=getCross(B,C,E)*getCross(D,A,E);

    if(num1>=0&&num2>=0) return true;

    return false;

}

//数据懒加载
export function TimedChunk(items, process, context, callback) {

    let todo = items.concat(), delay = 25, index = 0,newArr=[];

    function _callee() {
        let start = +new Date();

        do {
            process.call(context, todo.shift(),items[index],index++);
        }
        while (todo.length > 0 && (+new Date() - start < 50));

        if (todo.length > 0) {
            setTimeout(_callee, delay);
        } else if (callback) {
            callback.call(context, items);
        }
    }

    _callee();
}


/************星期连接字符串缩减***************/
export function getWeekStr(week) {

    let weeksourc = [
            {
                num:1,
                name:'周一'
            },
            {
                num:2,
                name:'周二'
            },
            {
                num:3,
                name:'周三'
            },
            {
                num:4,
                name:'周四'
            },
            {
                num:5,
                name:'周五'
            },
            {
                num:6,
                name:'周六'
            },
            {
                num:7,
                name:'周日'
            }
        ],
        $curr = [],
        $str='';

    // ['周日','周一','周二','周三','周四','周五','周六']
    // week = ['周日','周一','周二','周三','周四','周五','周六']

    for(let i=0;i<week.length;i++){
        for(let j=0;j<weeksourc.length;j++){
            let day = weeksourc[j];
            if(day.name == week[i]){
                $curr.push(day)
            }
        }
    }

    if($curr.length > 1){
        //排序
        $curr.sort((v1,v2)=>{return v1.num - v2.num})
    }

    if($curr.length < 3){

        if($curr.length>0){
            $curr.map(item=>{
                $str += item.name+'、';
            })
        }

    }else{

        let Snum = $curr[0].num,
            Enum = $curr[0].num,
            Sindex=0,
            Eindex=0,
            con=false;

        for(let i=0;i<$curr.length;i++){

            if($curr[i+1] && $curr[i].num+1 == $curr[i+1].num){
                con = true;
                Enum = $curr[i+1].num;
                Eindex = i+1;

            }else{

                if(i==$curr.length){
                    if($curr[i].num == $curr[i-1].num - 1){
                        Enum = $curr[i].num;
                        Eindex = i;
                    }
                }

                con = false
            }


            if(!con){

                if(Enum - Snum > 1){

                    $str += $curr[Sindex].name +'~'+$curr[Eindex].name+'、';

                }else{

                    if(Eindex <= Sindex){

                        $str += $curr[Sindex].name+'、';

                    }else{
                        $str += $curr[Sindex].name+'、'+$curr[Eindex].name+'、';
                    }
                }

                if(i+1<$curr.length){Snum = $curr[i+1].num;Sindex = i+1}

            }
        }
    }
    $str = $str.slice(0,$str.length - 1)
    return $str;

}




/************文字语音转换***************/

let $Once_Audios = false,
    $AudioAise = {},
    $Global_Audios = document.createElement('audio');

document.body.appendChild($Global_Audios);

document.addEventListener('click',()=>{
    if(!$Once_Audios){
        $Once_Audios = true;
        $Global_Audios.src = '';
        $Global_Audios.play();
        $Global_Audios.pause();
    }

    /*

    getAudioSrcFromText({
        text:"优质的代码使人心情愉快",
        types:3,
        spd:5,
        pit:5,
        vol:10,
        xhrType:"GET"
    },(audio,err)=>{
        if(err){
            console.log('音频加载失败');
        }
        else{
            audio.play();
        }
    })

    */
})

//get请求限制254字节  post限制4096
export function getAudioSrcFromText(param,callback) {

    param = param || {};

    //默认GET
    param.xhrType = param.xhrType || 'GET';
    param.types = param.types || 3;
    param.spd = param.spd || 4;
    param.vol = param.vol || 8;


    if(!param.text){
        callback && callback($Global_Audios,'err');
        return;
    }


    //降低重复语音请求
    if($AudioAise[param.text]){
        $Global_Audios.src =  $AudioAise[param.text];

        //重新加载音频(防止音频交叉||连续干扰)
        $Global_Audios.load();

        callback && callback($Global_Audios);
        return;
    }

    let httpStr = '',
        httpRequest = new XMLHttpRequest(),
        httpUrl = `https://web.sdk.map.brtbeacon.com/api/voice/txt_to_voice`;

    httpRequest.responseType = 'blob';

    httpRequest.onreadystatechange = function () {
        if(httpRequest.readyState === 4 && httpRequest.status !==404){
            let blob = httpRequest.response,
                reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function (e) {

                $Global_Audios.src = e.target.result.replace("application/octet-stream", "audio/mp3");

                //记录储存
                $AudioAise[param.text] = $Global_Audios.src;

                //重新加载音频
                $Global_Audios.load();

                callback && callback($Global_Audios);

            }
        }
    }


    if(['GET','get'].indexOf(param.xhrType) > -1){

        for(let key in param){
            if(param[key])httpStr += `${key}=${param[key]}&`;
        }

        if(httpStr){
            httpStr = httpStr.slice(0,httpStr.length-1);
            httpUrl += `?${httpStr}`;
        }

        httpRequest.open(param.xhrType,httpUrl,true);
        httpRequest.send();

        return;
    }

    //post
    httpRequest.open(param.xhrType,httpUrl,true);
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.send(JSON.stringify(param))

}

/************文字语音转换***************/
